import UtilService from "../services/util.service";

export default {
  name: "toNumber",
  fn: (value, decimals, program) => {
    return UtilService.toNumber(value, decimals, program);
  }
};
